import axios from 'axios';
import { getAPIHost } from '../../utils';

const uploadMonthlyQuota = (formData, year, month) =>
    new Promise((resolve, reject) => {
        axios
            .post(`${getAPIHost()}/upload-monthly-quotas/${year}/${month}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to upload file'));
            });
    });

export default uploadMonthlyQuota;
